import Utils from 'core-helpers/utils.js';
import PlansHelper from 'core-helpers/plans-helper.js';
import PlansService from 'premium/plans-service.js';

(function(root, doc, undefined) {

    // Vars
    const priceElement = Utils.getById('premium-price');

    const setPrice = (price) => {
        priceElement.innerHTML += price;
        Utils.removeClass(priceElement, 'hide');
    };

    const showPrice = (response) => {

        const allPlans = PlansHelper.getAllProductsPlans(response);
        const cheapestPlan = PlansHelper.getCheapestPlan(allPlans);
        const formattedPlan = PlansHelper.getFormattedPlan(cheapestPlan);

        if (!formattedPlan) {
            return false;
        }

        let price = formattedPlan.hasDiscount ? formattedPlan.monthlyPriceAfterDiscount : formattedPlan.monthlyPrice;
        setPrice(price);

    };

    const fetchPlans = () => {
        return PlansService.getTieredPlans();
    };

    const init = () => {
        if (priceElement) {
            fetchPlans()
                .then(showPrice);
        }
    };

    init();

})(window, document);
